import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActionApiKey, ActionConfig, FieldConfig, FieldType, TagType } from './form.type';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormService } from './form.service';
import { SelectModule } from 'primeng/select';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FiltersComponent } from '../filters/filters.component';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import { ApiKeyModalComponent } from '../../pages/user/modals/api-key-modal/api-key-modal.component';
import { DialogModule } from 'primeng/dialog';
import { ModalConfig, Severity } from '../../pages/user/modals/modal-config';
import { KeyStatus } from '../../pages/user/models/user.utils';
import { UserService } from '../../pages/user/services/user.service';
import { Message } from 'primeng/message';
import { UserApiKey } from '../../pages/user/models/user';
import { PhoneInputComponent } from '../phone-input/phone-input.component';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';

@Component({
  selector: 'app-dynamic-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    MultiSelectModule,
    SelectModule,
    ButtonModule,
    TranslateModule,
    TooltipModule,
    TagModule,
    ApiKeyModalComponent,
    DialogModule,
    Message,
    PhoneInputComponent,
    IconField, InputIcon
  ],
  templateUrl: './dynamic-form.component.html',
  styleUrl: './dynamic-form.component.scss',
  providers: [DialogService],
})
export class DynamicFormComponent implements OnInit, AfterViewInit {
  form: FormGroup = new FormGroup({});
  @Input() fields?: FieldConfig[];
  @Input() type = '';
  @Input() editable = true;
  @Input() translation = false;
  @Output() changes = new EventEmitter<any>();
  @Output() formChanges = new EventEmitter<any>();
  @Output() action = new EventEmitter<any>();

  types = FieldType;
  tagType = TagType;
  isKeyActivated: boolean = false;
  isKeyRegenerated: boolean = false;
  actionApiKeyActivate = ActionApiKey.activate;
  KeyStatusNonActivated = KeyStatus.non_activee;
  keyStatusActivated = KeyStatus.activee;
  error;
  KeyStatus;

  @ViewChild(ApiKeyModalComponent) modalDialog: ApiKeyModalComponent;

  // Configuration de la modal activate key api avec l'interface ModalConfig
  activateKeyApiModalConfig: ModalConfig = {
    display: false,
    headerTitle: 'modalApiKey.activateKeyApi.title',
    content: 'modalApiKey.activateKeyApi.content',
    link: true,
    linkContent: {
      text: 'modalApiKey.clickHere',
      href: 'https://partners-test-catalog-mp.fnacdarty.com/docapi/',
      icon: false,
    },
    linkLabel: 'modalApiKey.activateKeyApi.linkLabel',
    showFooter: true,
    additionnalText: true,
    additionnalTextContent: 'modalApiKey.activateKeyApi.extraContent',
    additionnalTextStyle: { 'font-weight': '800' },
    footerButtons: [
      {
        label: 'modalApiKey.undo',
        icon: 'pi pi-times-circle',
        severity: Severity.secondary,
        action: () => this.closeActivateApiKeyModal(),
      },
      {
        label: 'modalApiKey.activateKeyApi.title',
        icon: 'pi pi-check-square',
        severity: Severity.info,
        action: () => this.activateApiKey(),
      },
    ],
    dialogStyle: { width: '35%', height: 'auto' },
    buttonStyle: { margin: '5px' },
    linkLabelStyle: { 'font-weight': '350', color: ' #33a757', 'font-size': '14px !important' },
    linkContentStyle: { color: '#33a757', 'font-weight': '600', 'text-decoration': 'underline' },
  };

  activatedKeyApiModalConfig: ModalConfig = {
    display: false,
    headerTitle: 'modalApiKey.activateKeyApi.title',
    content: 'modalApiKey.activatedKeyApi.content',
    link: true,
    linkContent: {
      icon: true,
      iconButton: {
        icon: 'pi pi-copy',
        severity: Severity.secondary,
      },
    },
    linkLabel: '',
    additionnalText: false,
    dialogStyle: { width: '35%', height: 'auto' },
    linkLabelStyle: { color: '#33a757', 'font-weight': '600' },
  };

  regenerateKeyApiModalConfig: ModalConfig = {
    display: false,
    headerTitle: 'modalApiKey.generateKeyApi.title',
    content: 'modalApiKey.generateKeyApi.content',
    link: true,
    linkContent: {
      text: 'modalApiKey.clickHere',
      href: 'https://partners-test-catalog-mp.fnacdarty.com/docapi/',
      icon: false,
    },
    linkLabel: 'modalApiKey.generateKeyApi.linkLabel',
    showFooter: true,
    additionnalText: true,
    additionnalTextContent: 'modalApiKey.generateKeyApi.extraContent',
    additionnalTextStyle: { 'font-weight': '800' },
    footerButtons: [
      {
        label: 'modalApiKey.undo',
        icon: 'pi pi-times-circle',
        severity: Severity.secondary,
        action: () => this.closeRegenerateApiKeyModal(),
      },
      {
        label: 'modalApiKey.generateKeyApi.title',
        icon: 'pi pi-check-square',
        severity: Severity.info,
        action: () => this.regenerateApiKey(),
      },
    ],
    dialogStyle: { width: '35%', height: 'auto' },
    buttonStyle: { margin: '5px' },
    linkLabelStyle: { 'font-weight': '350', color: ' #33a757', 'font-size': '14px !important' },
    linkContentStyle: { color: '#33a757', 'font-weight': '600', 'text-decoration': 'underline' },
  };

  regeneratedKeyApiModalConfig: ModalConfig = {
    display: false,
    headerTitle: 'modalApiKey.generateKeyApi.title',
    content: 'modalApiKey.activatedKeyApi.content',
    link: true,
    linkContent: {
      icon: true,
      iconButton: {
        icon: 'pi pi-copy',
        severity: Severity.secondary,
      },
    },
    footerButtons: [],
    linkLabel: '',
    additionnalText: false,
    dialogStyle: { width: '35%', height: 'auto' },
    linkLabelStyle: { color: '#33a757', 'font-weight': '600' },
  };
  user: any;
  constructor(
    public formService: FormService,
    public dialogService: DialogService,
    private readonly cd: ChangeDetectorRef,
    private readonly userService: UserService,
    private readonly translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.form = this.formService.toFormGroup(this.fields);
    this.form.valueChanges.subscribe({
      next: () => {
        this.changes.emit(this.form.value);
        this.formChanges.emit(this.form);
      },
    });
  }


  ngAfterViewInit(): void {
    this.formChanges.emit(this.form);
  }

  openDialog() {
    this.dialogService.open(FiltersComponent, {
      width: '80%',
      height: '80%',
    });
  }

  allowOnlyAlphabets(event, verify) {
    const char = String.fromCodePoint(event.keyCode);
    if (verify && !/[a-zA-Z- ]/.test(char)) {
      event.preventDefault();
    }
  }  
  allowOnlyNumbers(event: KeyboardEvent, verify: boolean): void {
    const char = event.key;

    // Allow control keys (e.g., Backspace, Arrow keys, Delete, Tab)
    if (['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(char)) {
      return;
    }
  
    // Get the current value of the input field
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;
  
    // Regular expressions for validation
    const validPattern = /^\d$/;
    const validWithPlus = /^\+$/;
  
    // Check length limit and invalid characters
    if (
      verify &&
      (currentValue.length >= 15 || // Prevent input if length exceeds maxLength
        !(
          validPattern.test(char) || 
          (validWithPlus.test(char) && currentValue.length === 0) // Allow "+" only at the start
        ))
    ) {
      event.preventDefault();
    }
  }

  openActivateApiKeyModal() {
    this.activateKeyApiModalConfig.display = true;
    this.cd.detectChanges();
  }

  closeActivateApiKeyModal() {
    if (this.isKeyActivated) {
      this.activatedKeyApiModalConfig.display = false;
      this.isKeyActivated = false;
      this.updateApiKeyStatus(this.KeyStatus);
    } else {
      this.activateKeyApiModalConfig.display = false;
    }

    this.cd.detectChanges();
  }

  openRegenerateApiKeyModal() {
    this.regenerateKeyApiModalConfig.display = true;
    this.cd.detectChanges();
  }

  closeRegenerateApiKeyModal() {
    if (this.isKeyRegenerated) {
      this.regeneratedKeyApiModalConfig.display = false;
      this.isKeyRegenerated = false;
    } else {
      this.regenerateKeyApiModalConfig.display = false;
    }

    this.cd.detectChanges();
  }
  activateApiKey() {
    this.userService.generateApiKey().subscribe({
      next: (res: UserApiKey) => {
        this.activateKeyApiModalConfig.display = false;
        this.isKeyActivated = true;
        this.activatedKeyApiModalConfig.linkLabel = res.apiKey;
        this.activatedKeyApiModalConfig.display = true;
        this.KeyStatus = res.keyStatus;
        this.cd.detectChanges();
      },
      error: () => {
        this.closeActivateApiKeyModal();
        this.error = 
          {
            severity: 'error',
            text: this.translate.instant('modalApiKey.activateKeyApi.error'),
          };
      }
    });
  }
  updateApiKeyStatus(keyStatus) {
    let user = this.userService.getUser();
    let actionConfig: ActionConfig = {
      isDisplayed: true,
    };
    let apiKeyField = this.fields.find((field) => field.name === 'apiKey');
    apiKeyField.value = 'keyStatus.' + keyStatus;
    apiKeyField.status = keyStatus;
    actionConfig.type = ActionApiKey.regenerate;
    apiKeyField.actionButton = actionConfig;
    this.userService.setUser({ ...user, keyStatus: KeyStatus.activee });
  }
  regenerateApiKey() {
    this.userService.generateApiKey().subscribe({
      next: (res: UserApiKey) => {
        this.regenerateKeyApiModalConfig.display = false;
        this.isKeyRegenerated = true;
        this.regeneratedKeyApiModalConfig.linkLabel = res.apiKey;
        this.regeneratedKeyApiModalConfig.display = true;
        this.cd.detectChanges();
      },
      error: () => {
        this.closeRegenerateApiKeyModal();
        this.error = 
          {
            severity: 'error',
            text: this.translate.instant('modalApiKey.generateKeyApi.error'),
          };
      },
    });
  }

  emitAction(action) {
    this.action.emit(action);
  }
}
